import React from 'react';
import { NavLink } from 'react-router-dom';
import { useContractState } from '../../context/ContractContext';

const Icon = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9v11a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9" />
    </svg>
  ),
  invest: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v10M8 10h6a2 2 0 0 1 0 4H9" />
    </svg>
  ),
  nft: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M3 15l5-5 4 4 3-3 6 6" />
      <circle cx="9" cy="9" r="1.5" fill="currentColor" />
    </svg>
  ),
  team: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="10" r="2.5" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <path d="M15 20c0-2.4 1.6-4.4 4-5" />
    </svg>
  ),
  admin: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  )
};

const BASE_TABS = [
  { to: '/',        label: 'Home',    icon: Icon.home },
  { to: '/invest',  label: 'Invest',  icon: Icon.invest },
  { to: '/nfts',    label: 'My NFTs', icon: Icon.nft },
  { to: '/team',    label: 'Team',    icon: Icon.team }
];

export default function BottomNav() {
  const { isOwner, isAdmin } = useContractState();
  const tabs = isOwner || isAdmin
    ? [...BASE_TABS, { to: '/admin', label: 'Admin', icon: Icon.admin }]
    : BASE_TABS;
  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-inner" style={{ gridTemplateColumns: `repeat(${tabs.length}, 1fr)` }}>
        {tabs.map(t => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === '/'}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="icon">{t.icon}</span>
            <span>{t.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
